import React from 'react';

import { Hourglass } from 'lucide-react';
import { useTranslation } from 'react-i18next';

import { Button } from '@/components/ui/button';
import { SupportModal } from '@/modules/common';
import { LogoutConfirmationModal } from '@/modules/common/components/modals/logout-confirmation-modal';

export const TrialEndedScreen: React.FC = () => {
  const { t } = useTranslation('common');

  return (
    <div className="flex flex-1 items-center justify-center bg-background">
      <div className="flex w-[513px] flex-col items-center text-center">
        <div className="flex h-16 w-16 items-center justify-center rounded-full bg-muted">
          <Hourglass className="h-6 w-6 text-foreground" />
        </div>
        <h1 className="mt-6 text-2xl font-semibold text-foreground">{t('demo.trialEndedTitle')}</h1>
        <p className="mt-4 text-sm text-muted-foreground">{t('demo.trialEndedSubtitle')}</p>
        <div className="mt-6 flex gap-3">
          <LogoutConfirmationModal
            trigger={
              <Button variant="outline" className="w-[176px]">
                {t('logout')}
              </Button>
            }
          />
          <SupportModal>
            <Button className="w-[176px]">{t('contactSupport')}</Button>
          </SupportModal>
        </div>
      </div>
    </div>
  );
};
